import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/returns.scss";

function Returns() {
  return (
    <div className="returns">
      <Header />
      <div className="page_template mce__content dj-mce-view">
        <h3 className="tw-m-0 tw-text-center tw-title-base type-title-font-family page_template__title dj_skin_title_font">
          Return &amp; Exchange Policy
        </h3>
        <div className="tw-mt-10 tw-leading-normal dj_skin_text">
          <p><strong>Last updated: October 16, 2026</strong></p>
          <p>
            Contact <a href="mailto:cost@averlynxstore.one">cost@averlynxstore.one</a>
            before returning an item. Include your order number, the item, and
            the reason for the request. We will provide the applicable return
            instructions and destination.
          </p>
          <p><strong>1. Return window and condition</strong></p>
          <p>
            Unless a different period is required by applicable law, return
            requests should be made within 30 days after delivery. Items must be
            unworn, unwashed, undamaged, and returned with original tags and
            packaging. Proof of purchase is required.
          </p>
          <p><strong>2. Incorrect, damaged, or defective items</strong></p>
          <p>
            Contact us promptly and include clear photos of the item and package.
            If we confirm that an item arrived incorrect, damaged, or defective,
            we will provide an appropriate replacement, refund, or other remedy
            and cover reasonable return shipping where required.
          </p>
          <p><strong>3. Change-of-mind returns and exchanges</strong></p>
          <p>
            Approved change-of-mind returns may require the customer to pay
            return shipping. Original delivery charges are non-refundable except
            where required by law. Exchanges depend on stock availability; when
            a direct exchange is unavailable, we may issue a refund so a new
            order can be placed.
          </p>
          <p><strong>4. Non-returnable items</strong></p>
          <p>
            Items marked final sale, gift cards, personalized goods, and products
            that cannot be resold for hygiene reasons may be non-returnable unless
            faulty or applicable law provides otherwise. Product-page notices
            identify any item-specific exception.
          </p>
          <p><strong>5. Refund timing</strong></p>
          <p>
            Once an approved return is received and inspected, we will notify you
            of the outcome. Approved refunds are sent to the original payment
            method. Your bank or payment provider may need additional time to post
            the credit.
          </p>
          <p><strong>6. Cancellations</strong></p>
          <p>
            Contact us as soon as possible if you need to cancel. We cannot
            guarantee cancellation after fulfillment begins. If an order has
            shipped, the return process above applies.
          </p>
          <p><strong>7. Return shipping and proof</strong></p>
          <p>
            Use the return method and destination we provide. If a product page,
            checkout notice, or promotion includes free returns, the offered
            method must be used unless we agree otherwise. Keep tracking and
            proof of drop-off until the return is completed. We are not
            responsible for a return sent to the wrong address or lost through a
            service you arranged, except where applicable law provides otherwise.
          </p>
          <p><strong>8. Gifts, bundles, and promotional purchases</strong></p>
          <p>
            An eligible gift may be refunded to the original payment method or,
            with appropriate verification, resolved through store credit where
            available and lawful. Refunds reflect the amount actually paid. A
            partial return from a bundle may be recalculated under the disclosed
            promotion terms.
          </p>
          <p><strong>9. Statutory withdrawal and consumer rights</strong></p>
          <p>
            Where a statutory cooling-off or withdrawal right applies, you may
            notify us within the legal period even if our standard process is
            different. For eligible distance sales in the European Economic Area,
            that period is generally 14 days after physical receipt, subject to
            legal exceptions. You then return the goods within the applicable
            period. Nothing in this policy limits remedies for products that are
            faulty, unsafe, misdescribed, or otherwise non-conforming.
          </p>
          <p><strong>10. Refund deductions</strong></p>
          <p>
            We may make only deductions permitted by law, such as a loss in value
            caused by handling beyond what is reasonably needed to inspect an
            item. We will not charge a restocking fee unless it was clearly
            disclosed before purchase and is lawful for the transaction.
          </p>
          <p><strong>11. Contact</strong></p>
          <p>Email: <a href="mailto:cost@averlynxstore.one">cost@averlynxstore.one</a></p>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Returns;
